/**
 * Adapts a hook's `data`, `isLoading`, and `error` into the `query` shape
 * expected by `QueryBoundary` when the source is not a React Query result.
 */
import type { QueryBoundaryQuery } from './types';

function toQueryResult<TData>(data: TData, isLoading: boolean, error: unknown, refetch: () => Promise<unknown>): QueryBoundaryQuery<TData> {
  const hasError = Boolean(error);

  return {
    data: isLoading || hasError ? undefined : data,
    isPending: isLoading && !hasError,
    error,
    refetch,
  };
}

export { toQueryResult };
